export default __webpack_public_path__ + "static/media/jemstone-logo.3ee804b9.png";